export enum NormalizedRentType {
  ONE_ROOM_KOKSKAP = '1 rum och kokskåp',
  ONE_ROOM_KOKVRA = '1 rum och kokvrå',
  ONE_ROOM_KOK = '1 rum och kök',
  ONE_HALF_ROOM_KOK = '1,5 rum och kök',
  TWO_ROOM_KOKVRA = '2 rum och kokvrå',
  TWO_ROOM_KOK = '2 rum och kök',
  TWO_HALF_ROOM_KOK = '2,5 rum och kök',
  THREE_ROOM_KOK = '3 rum och kök',
  THREE_HALF_ROOM_KOK = '3,5 rum och kök',
  FOUR_ROOM_KOK = '4 rum och kök',
  FOUR_HALF_ROOM_KOK = '4,5 rum och kök',
  FIVE_ROOM_KOK = '5 rum och kök',
  SIX_ROOM_KOK = '6 rum och kök',
  SEVEN_ROOM_KOK = '7 rum och kök',
  EIGHT_ROOM_KOK = '8 rum och kök'
}

export type ObjectSizeMapping = {
  id: string
  customer_id: string
  boverket_type: NormalizedRentType
  value: string
  created_at: string
  updated_at: string
}

export type PostObjectSizeMappingBody = {
  boverket_type: NormalizedRentType
  value: string
}

export type ObjectSizeMappingsRedux = {
  [customerId: string]: ObjectSizeMapping[]
}
